import { render, staticRenderFns } from "./ProductThreshold.vue?vue&type=template&id=72a3e635&scoped=true"
import script from "./ProductThreshold.vue?vue&type=script&lang=js"
export * from "./ProductThreshold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a3e635",
  null
  
)

export default component.exports